import React, { useState, useEffect, useRef } from 'react';
import './Product_ifile27.css';

const Product_ifile27 = () => {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const benefits = [
    {
      icon: "bi-gear-wide-connected",
      title: "Individuals",
      desc: "Personal documents, certificates, property records and applications.",
      color: "#3b82f6", 
    },
    {
      icon: "bi-person-dash",
      title: "Government and public-service offices",
      desc: "Citizen records, service applications, verification and approvals.",
      color: "#0ea5e9", 
    },
    {
      icon: "bi-eye",
      title: "Housing and cooperative societies",
      desc: "Member files, NOCs, transfers, complaints and committee approvals.",
      color: "#10b981", 
    },
    {
      icon: "bi-android",
      title: "Colleges and educational institutions",
      desc: "Student files, admissions, certificates and administrative requests.",
      color: "#6366f1", 
    },
    {
      icon: "bi-shield-lock-fill",
      title: "Hospitals",
      desc: "Employee and vendor records, administrative requests, compliance files and service tickets.",
      color: "#ef4444", 
    },
    {
      icon: "bi-bar-chart-line-fill",
      title: "Businesses and service organizations",
      desc: "Customer records, document workflows, internal requests and operational ticketing.",
      color: "#14b8a6", 
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="busi-ifile-wrapper">
      
      {/* Header */}
      <div className="busi-ifile-header pb-4">
        {/* <span className="busi-ifile-badge">Why Choose Us</span> */}
        <h2 className="busi-ifile-text-center busi-ifile-title">Who Can Benefit from iTixFiles</h2>
        {/* <h2 className="busi-ifile-text-center busi-ifile-title1"> for Modern File Management</h2> */}
         <p className="pd9-sub">
  Enhance efficiency, reduce manual work, and gain complete control over your documents with intelligent automation and real-time insights.
</p>
        {/* <div className="busi-ifile-decor"></div> */}
      </div>

      {/* Grid: 3 Cards Per Row */}
      <div className="busi-ifile-grid">
        {benefits.map((item, index) => (
          <div 
            key={index} 
            className={`busi-ifile-card ${isVisible ? 'busi-ifile-visible' : ''}`}
            style={{ 
              transitionDelay: isVisible ? `${index * 100}ms` : '0ms'
            }}
          >
            {/* Icon with Gradient Circle Background */}
            <div className="busi-ifile-icon-box">
              <i className={`bi ${item.icon}`}></i>
            </div>
            
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Product_ifile27;